import { makeAutoObservable } from 'mobx';

import { inventoryItems } from '@/mocks/inventory-items';
import { InventoryItem } from '@/shared/types/common';

export type TradeStatuses =
  | 'created'
  | 'verification'
  | 'getItems'
  | 'success'
  | 'error';

export type GuideSteps = 1 | 2 | 3 | 4 | 5 | null;

type RobloxUserInfo = {
  id: string;
  accountType: number;
  robloxAccountId: string;
  robloxAccountName: string;
  robloxAccountAvatarUrl: string;
};

export type Trade = {
  id: string;
  status: TradeStatuses;
  linkedRobloxAccount: RobloxUserInfo;
  date: string;
  items: InventoryItem[];
};

const trades: Trade[] = [
  {
    id: '5373754433',
    status: 'created',
    linkedRobloxAccount: {
      id: '113576',
      accountType: 0,
      robloxAccountId: '3355099923',
      robloxAccountName: 'Mkskkdd',
      robloxAccountAvatarUrl:
        'https://tr.rbxcdn.com/30DAY-Avatar-24202AAF7C52594C3D76F825A247F47D-Png/150/150/Avatar/Png/noFilter',
    },
    date: '2025-04-14T06:38:08.187Z',
    items: inventoryItems.slice(0, 2),
  },
  {
    id: '53733423754433',
    status: 'getItems',
    linkedRobloxAccount: {
      id: '1135e3276',
      accountType: 0,
      robloxAccountId: '335509934923',
      robloxAccountName: 'RobloxTop1',
      robloxAccountAvatarUrl:
        'https://tr.rbxcdn.com/30DAY-Avatar-24202AAF7C52594C3D76F825A247F47D-Png/150/150/Avatar/Png/noFilter',
    },
    date: '2025-04-14T06:38:08.187Z',
    items: inventoryItems.slice(1, 3),
  },
];

class ItemsWithdrawalStore {
  cards = inventoryItems;
  selectedIds: number[] = [];
  selectedAccountAge: 'under' | 'above' | null = null;
  step: number = 0;
  createTradeOpened = false;
  selectedTrade: string | null = null;
  trades = trades;
  guideStep: GuideSteps = null;

  constructor() {
    makeAutoObservable(this);
  }

  clearCards() {
    this.cards = [];
  }

  setSelectedAccountAge(age: 'above' | 'under' | null) {
    this.selectedAccountAge = age;
  }

  setTimesUp(itemId: number) {
    if (this.selectedIds.includes(itemId)) {
      this.selectedIds = this.selectedIds.filter(
        currentId => currentId !== itemId,
      );
    }
    this.cards.forEach(card => {
      if (card.id === itemId) {
        card.timesUp = true;
      }
    });
  }

  toggleSelected(itemId: number) {
    if (this.selectedIds.includes(itemId)) {
      this.selectedIds = this.selectedIds.filter(
        currentId => currentId !== itemId,
      );
    } else if (this.selectedIds.length < 4) {
      this.selectedIds = [itemId, ...this.selectedIds];
    }
  }

  selectAll() {
    const sortedItems = this.cards
      .filter(card => !card.timesUp)
      .sort((card1, card2) => {
        const card1Timer =
          typeof card1.timer !== 'number'
            ? parseInt(card1.timer) * 86400
            : card1.timer;
        const card2Timer =
          typeof card2.timer !== 'number'
            ? parseInt(card2.timer) * 86400
            : card2.timer;

        return card2Timer - card1Timer;
      });

    this.selectedIds = sortedItems.slice(-4).map(item => item.id);
  }

  openCreateTrade() {
    this.createTradeOpened = true;
  }

  closeCreateTrade() {
    this.createTradeOpened = false;
  }

  setSelectedTrade(id: string | null) {
    this.selectedTrade = id;
  }

  getSelectedTrade() {
    return this.trades.find(trade => trade.id === this.selectedTrade);
  }

  updateTradeStatus(status: TradeStatuses) {
    const item = this.trades.find(curr => curr.id === this.selectedTrade);

    if (item) {
      item.status = status;
    }
  }

  nextGuideStep() {
    if (this.guideStep && this.guideStep < 5) {
      this.guideStep = (this.guideStep + 1) as GuideSteps;
    }
  }

  prevGuideStep() {
    if (this.guideStep && this.guideStep > 1) {
      this.guideStep = (this.guideStep - 1) as GuideSteps;
    }
  }

  setGuideStep(step: GuideSteps) {
    this.guideStep = step;
  }

  deselect() {
    this.selectedIds = [];
  }
}

export const itemsWithdrawalStore = new ItemsWithdrawalStore();
